var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "home",
    staticStyle: {
      background: "#fff"
    }
  }, [_c("div", {
    staticStyle: {
      "font-size": "36px",
      "text-align": "center",
      "margin-top": "120px"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.home")))])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };